import { render } from "./detail-result-ag.vue?vue&type=template&id=2871fccc"
import script from "./detail-result-ag.vue?vue&type=script&lang=js"
export * from "./detail-result-ag.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__